import React from 'react';

import type { MarketplacePropertySearchResultFragment } from '__generated__/athena/graphql';

import { buildAddressPreviewParams } from '../helpers/useSearchQueries';
import type { PropertyReactions } from '../types';
import { MapMarker } from './MapMarker';
import type { MapMarkerProps, TopMarker } from './types';

interface MarketplaceMapMarkerProps extends Omit<MapMarkerProps, 'property' | 'onClick'> {
  property: MarketplacePropertySearchResultFragment;
  topMarker: TopMarker | null;
  handleFetchPropertyDetails: (addressToken: string) => Promise<void>;
  setTopMarker: React.Dispatch<React.SetStateAction<TopMarker | null>>;
  propertyReactions?: PropertyReactions;
  isSelected?: boolean;
  isLoading?: boolean;
}

export const MarketplaceMapMarker: React.FC<MarketplaceMapMarkerProps> = ({
  property,
  handleFetchPropertyDetails,
  propertyReactions,
  isSelected,
  isLoading,
}) => {
  const addressToken = property.addressToken;
  if (addressToken === null || addressToken === undefined) {
    return null;
  }

  const lat = property.location?.lat;
  if (lat === undefined) {
    return null;
  }

  const lon = property.location?.lon;
  if (lon === undefined) {
    return null;
  }

  const handleOnClick = () => {
    handleFetchPropertyDetails(addressToken);
    const urlParams = buildAddressPreviewParams(addressToken);
    window.history.pushState({}, '', `${window.location.pathname}?${urlParams}`);
  };

  const reactionForMarker = propertyReactions?.[addressToken];
  const isLiked = reactionForMarker
    ? reactionForMarker === 'REACTION_LIKE'
    : (property.isLiked ?? false);

  const markerProperty = {
    ...property,
    addressToken,
    location: {
      lat,
      lon,
    },
    isLiked,
  };

  return (
    <MapMarker
      key={property.addressToken}
      property={markerProperty}
      onClick={handleOnClick}
      isSelected={isSelected}
      isLoading={isLoading}
    />
  );
};
